import Repository from '../axios'
import {defaultPagination} from "@/constants/config";

const  resource = "/landlord/roles";
export default {
  get(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`/user/profiles?limit=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getListNoPagination() {
    return Repository.get(`/user/profiles`)
  },
  getRole(role_id) {
    return Repository.get(`/user/profiles/${role_id}/view`)
  },
  updateRole(role_id, payload) {
    return Repository.put(`/user/profiles/${role_id}/update`, payload)
  },
  createRole(payload) {
    return Repository.post(`/user/profiles/create`, payload)
  },
};
